// extracted by mini-css-extract-plugin
module.exports = {"skill-card":"SkillCard_skill-card__2rYwy","skill-icon":"SkillCard_skill-icon__2VW5x","skill-name":"SkillCard_skill-name__1bm0U"};